import { BaseBuildPart } from './../base-build-part';
import { HelperParams } from './../helper-params';

export class SampleTrackingReportBuildPart extends BaseBuildPart {
    constructor(
        private readonly reportHelperParams: HelperParams,
        parent: BaseBuildPart) {
        super(reportHelperParams, parent, ['reports']);
    }

    public home(): BaseBuildPart {
        return new BaseBuildPart(this.reportHelperParams, this, ['overview']);
    }

    public GeneratedReports(): BaseBuildPart {
        return new BaseBuildPart(this.reportHelperParams, this, ['view', 'generated-reports']);
    }

    public ScheduledReports(): BaseBuildPart {
        return new BaseBuildPart(this.reportHelperParams, this, ['view', 'scheduled-reports']);
    }

    public NewGenerateReport(reportTypeId: number): BaseBuildPart {
        return new BaseBuildPart(this.reportHelperParams, this, ['new-report', reportTypeId, 'generate']);
    }

    public NewScheduledReport(reportTypeId: number): BaseBuildPart {
        return new BaseBuildPart(this.reportHelperParams, this, ['new-report', reportTypeId, 'schedule']);
    }
}
